import React, { useState } from 'react'
import PlayButton from '../shared/PlayButton'
import VideoOverlay from '../shared/VideoOverlay'

interface Props {
  buttonText: string
  youtubeEmbedUrl: string
  list: [
    {
      imageSrc: string
      title: string
      subTitle: string
      text: string
    }
  ]
}

const Employees: React.FunctionComponent<Props> = ({
  buttonText,
  youtubeEmbedUrl,
  list,
}) => {
  const [showVideoModal, videoIsVisible] = useState<boolean>(false)

  return (
    <section className="relative pt-10 xl:pt-0 mx-auto bg-transparent sm:px-8 lg:px-16 xl:px-28 text-nptBase">
      <div className="max-w-screen-2xl lg:mx-2 lg:my-3  xl:my-0 lg:pb-4 2xl:mx-auto">
        <div className="flex overflow-hidden lg:justify-center rounded-md">
          {list.map((item, i) => (
            <div
              key={`EmployeesList_${i}`}
              className={`w-full h-3/4  md:block md:min-w-1/2 lg:w-4/12 ${
                i === 0 ? '' : 'hidden'
              }`}
            >
              <img
                className={`object-cover w-full max-w-[90vw] h-3/4 xl:h-[565px] ${
                  i === 0 ? 'rounded-bl-md' : ''
                } ${i === 2 ? 'rounded-br-md' : ''}`}
                alt={item.title}
                src={item.imageSrc}
              />
              <div className=" grid justify-center xl:justify-start xl:ml-[110px] gap-2.5 text-green-100 text-nptBase xl:py-6 xl:gap-y-3 py-8 mb-4">
                <h2 className="text-[1.5rem] leading-[1.813rem] ">
                  {item.title}
                </h2>
                <p>{item.subTitle}</p>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {showVideoModal && youtubeEmbedUrl && (
        <VideoOverlay
          youtubeEmbedUrl={youtubeEmbedUrl}
          showVideoModal={showVideoModal}
          videoIsVisible={videoIsVisible}
        />
      )}
    </section>
  )
}

export default Employees
